import { c as _c } from "react/compiler-runtime";
import { LocalStorageContextType, LocalStorageProviderPropertiesType } from "@website/hooks/local-storage/local-storage.types";
import { isSSR } from "@website/utils/is-ssr";
import { FC, createContext, useContext } from "react";
export const LocalStorageContext = createContext<LocalStorageContextType>({
  addToLocalStorage: (() => null) as (key: string, value: string) => null,
  removeFromLocalStorage: (() => null) as (key: string) => null,
  getFromLocalStorage: (() => "") as (key: string) => string
});
export const LocalStorageProvider: FC<LocalStorageProviderPropertiesType> = t0 => {
  const $ = _c(6);
  const {
    children,
    version,
    prefix
  } = t0;
  let t1;
  if ($[0] !== prefix || $[1] !== version) {
    t1 = {
      addToLocalStorage: (key, value) => {
        if (isSSR()) {
          return;
        }
        localStorage.setItem(`${prefix}-${version}-${key}`, value);
      },
      removeFromLocalStorage: key_0 => {
        if (isSSR()) {
          return;
        }
        localStorage.removeItem(`${prefix}-${version}-${key_0}`);
      },
      getFromLocalStorage: key_1 => {
        if (isSSR()) {
          return null;
        }
        return localStorage.getItem(`${prefix}-${version}-${key_1}`);
      }
    };
    $[0] = prefix;
    $[1] = version;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const value_0 = t1;
  let t2;
  if ($[3] !== children || $[4] !== value_0) {
    t2 = <LocalStorageContext.Provider value={value_0}>{children}</LocalStorageContext.Provider>;
    $[3] = children;
    $[4] = value_0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useLocalStorage = () => {
  const context = useContext(LocalStorageContext);
  if (context === undefined) {
    throw new Error("useLocalStorage must be used within a LocalStorageProvider");
  }
  return context;
};